/**
 * Όλοι οι δυνατοί τύποι tokens που παράγει ο Lexer.
 * Κοινοί και για ΓΛΩΣΣΑ και για Ψευδογλώσσα — οι συντακτικές διαφορές
 * μεταξύ των δύο διαλέκτων αντιμετωπίζονται στον Parser (Φάση 2).
 */
export enum TokenType {
  // Literals
  NUMBER = 'NUMBER',
  STRING = 'STRING',
  IDENTIFIER = 'IDENTIFIER',

  // Δεσμευμένη λέξη (το ακριβές λήμμα βρίσκεται στο Token.value)
  KEYWORD = 'KEYWORD',

  // Τελεστές
  PLUS = 'PLUS', // +
  MINUS = 'MINUS', // -
  STAR = 'STAR', // *
  SLASH = 'SLASH', // /
  CARET = 'CARET', // ^

  ASSIGN = 'ASSIGN', // ← ή <-
  EQUAL = 'EQUAL', // =
  NOT_EQUAL = 'NOT_EQUAL', // <>
  LESS = 'LESS', // <
  LESS_EQUAL = 'LESS_EQUAL', // <=
  GREATER = 'GREATER', // >
  GREATER_EQUAL = 'GREATER_EQUAL', // >=

  DOT_DOT = 'DOT_DOT', // .. (διάστημα σε ΠΕΡΙΠΤΩΣΗ της ΕΠΙΛΕΞΕ, π.χ. "10..15")

  // Σημεία στίξης
  LPAREN = 'LPAREN', // (
  RPAREN = 'RPAREN', // )
  LBRACKET = 'LBRACKET', // [
  RBRACKET = 'RBRACKET', // ]
  COMMA = 'COMMA', // ,
  COLON = 'COLON', // :

  // Δομή / trivia
  COMMENT = 'COMMENT',
  NEWLINE = 'NEWLINE',
  EOF = 'EOF',
}
